import React, { useRef } from "react";
import { useState } from "react";

const FilterModal = ({
  minCost,
  maxCost,
  setMinCost,
  setMaxCost,
  language,
  platform,
  setPlatform,
  setLanguage,
  handleSubmit,
}) => {
  const ref = useRef();

  return (
    <div
      ref={ref}
      id="filterModal"
      className="absolute top-56 sm:top-7 right-1/2 sm:right-0 transform translate-x-1/2 sm:transform-none  z-50 rounded-md p-4 shadow-2xl bg-white w-72 flex flex-col gap-4 text-black"
      onMouseLeave={() => {
        ref.current.style.opacity = null;
        ref.current.style.display = null;
      }}
    >
      <div className="flex justify-between">
        <h1 className="font-semibold text-xl">Filters:</h1>
        <div
          onClick={() => {
            ref.current.style.opacity = "0";
            setTimeout(() => {
              ref.current.style.display = "none";
            }, 200);
          }}
        >
          <span tabIndex={0} className="cursor-pointer px-2 select-none">
            x
          </span>
        </div>
      </div>
      <CostRange
        minCost={minCost}
        maxCost={maxCost}
        setMinCost={setMinCost}
        setMaxCost={setMaxCost}
        handleSubmit={handleSubmit}
      />
      <LanguageSelect language={language} setLanguage={setLanguage} />
      <PlatformSelect platform={platform} setPlatform={setPlatform} />
    </div>
  );
};

export default FilterModal;

const CostRange = ({
  minCost,
  maxCost,
  setMinCost,
  setMaxCost,
  handleSubmit,
}) => {
  return (
    <>
      <h1 className="font-semibold text-base self-start">Cost</h1>
      <div className="flex flex-col relative h-10">
        <input
          className=" w-full pointer-events-none absolute z-10 h-10"
          type="range"
          step={10}
          name="mincost"
          min={0}
          max={5000}
          id=""
          value={minCost}
          onChange={(e) => setMinCost(Math.min(e.target.value, maxCost))}
          onMouseUp={(e) => {
            handleSubmit(e);
          }}
        />
        <input
          type="range"
          step={10}
          className=" w-full pointer-events-none absolute z-10 h-10"
          name="maxcost"
          min={0}
          max={5000}
          id=""
          value={maxCost}
          onChange={(e) => setMaxCost(Math.max(e.target.value, minCost))}
          onMouseUp={(e) => {
            handleSubmit(e);
          }}
        />

        <div className="absolute px-1 w-full bg-indigo-200 rounded-md h-2 top-1/2 transform -translate-y-1/2"></div>
        <div
          className="absolute px-1 w-full overflow-hidden top-1/2 transform -translate-y-1/2"
          style={{
            width: `${(maxCost - minCost) / 50}%`,
            left: `${(minCost - 1) / 50}%`,
          }}
        >
          <div className="bg-indigo-500 h-2"></div>
        </div>
      </div>
      <div className="flex gap-1">
        <input
          type="number"
          className="w-full appearance-none outline-none border-indigo-500 border-b-2"
          name="minCost"
          id=""
          value={minCost}
          min={0}
          max={5000}
          onChange={(e) => setMinCost(e.target.value)}
        />
        <span className="mx-2 font-semibold">$</span>
        <input
          type="number"
          className="w-full appearance-none outline-none border-indigo-500 border-b-2"
          name="maxCost"
          id=""
          value={maxCost}
          min={0}
          max={5000}
          onChange={(e) => setMaxCost(e.target.value)}
        />
        <span className="mx-2 font-semibold">$</span>
      </div>
    </>
  );
};

const LanguageSelect = ({ language, setLanguage }) => {
  const languageList = ["English", "Hindi", "Spanish"];

  const [languageState, setLanguageState] = useState(languageList);

  const handleLanguageSearch = (e) => {
    e.preventDefault();
    let string = `.*${e.target.value}.*`;
    let regex = new RegExp(string, "i");

    console.log(regex);
    setLanguageState(languageList.filter((item) => !item.search(regex)));
  };

  return (
    <>
      <h1 className="font-semibold text-base self-start">Language:</h1>

      <div className={`flex flex-col border-indigo-500 border-2 rounded-md`}>
        <input
          type="text"
          name="platform"
          onChange={(e) => handleLanguageSearch(e)}
          className="outline-none p-2 border-b-2 border-indigo-200 text-center rounded-md overflow-scroll"
          placeholder="Search"
        />
        <div className="transition-height max-h-40 overflow-auto p-1">
          {languageState.map((item) => (
            <button
              key={item}
              className={`transition-colors w-full block py-1 truncate rounded cursor-pointer outline-none text-center   ${
                language === `${item}` && "text-white bg-indigo-500"
              }`}
              value={item}
              onClick={(e) => setLanguage(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === "Spacebar") {
                  setLanguage(item);
                }
              }}
            >
              {item}
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

const PlatformSelect = ({ platform, setPlatform }) => {
  const platformList = ["Youtube", "Udemy", "LinkedIn"];

  const [platformState, setLanguageState] = useState(platformList);

  const handleLanguageSearch = (e) => {
    e.preventDefault();
    let string = `.*${e.target.value}.*`;
    let regex = new RegExp(string, "i");

    console.log(regex);
    setLanguageState(platformList.filter((item) => !item.search(regex)));
  };

  return (
    <>
      <h1 className="font-semibold text-base self-start">Platform:</h1>
      <div className={`flex flex-col border-indigo-500 border-2 rounded-md`}>
        <input
          type="text"
          name="platform"
          onChange={(e) => handleLanguageSearch(e)}
          className="outline-none p-2 border-b-2 border-indigo-200 text-center rounded-md overflow-scroll"
          placeholder="Search"
        />
        <div className="transition-height max-h-40 overflow-auto p-1">
          {platformState.map((item) => (
            <button
              key={item}
              className={`transition-colors w-full block py-1 truncate rounded cursor-pointer outline-none text-center   ${
                platform === `${item}` && "text-white bg-indigo-500"
              }`}
              value={item}
              onClick={(e) => setPlatform(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === "Spacebar") {
                  setPlatform(item);
                }
              }}
            >
              {item}
            </button>
          ))}
        </div>
      </div>
    </>
  );
};
